import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import { subDays, format } from "date-fns";
import {
  VictoryVoronoiContainer,
  VictoryAxis,
  VictoryChart,
  VictoryLine,
  VictoryTheme
} from "victory";
import qs from "qs";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  TimePicker,
  DatePicker
} from "material-ui-pickers";
import SleepChart from "./SleepChart";
import TableContainer from "@material-ui/core/TableContainer";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 7,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  grid: {
    marginTop: 60,
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  button: {
    height: 40,
    margin: theme.spacing.unit
  },
  datePicker: {
    margin: theme.spacing.unit * 2
  },
  container: {
	  maxHeight: 1000
  }
});

class Activities extends Component {
  state = {
    selectedDate: new Date(),
    date: new Date(),
    users: []
  };

  handleDateChange = date => {
    this.setState({ selectedDate: format(date, "yyyy-MM-dd") });
  };

  async getUserResource({ date }) {
    const uniqid = this.props.uniqid;
    const resource = this.props.resource;
    try {
      const result = await fetch(
        `/api/getSerialResourceByDate?resource=${resource}&uniqid=${uniqid}&date=${date}`,
        {
          mode: "cors",
          method: "GET"
        }
      );

      const data = await result.json();

      // error handling
      this.setState({ users: data });
    } catch (err) {
      console.log(err);
    }
  }

  componentDidMount() {
    const date =
      qs.parse(this.props.search, { ignoreQueryPrefix: true }).date ||
      format(new Date(), "yyyy-MM-dd");
    this.setState({
      date,
      selectedDate: date
    });
    this.getUserResource({ date });
  }

  render() {
    const { classes } = this.props;
    const { selectedDate, date } = this.state;

    return (
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Paper>
            <Grid container className={classes.grid} justify="space-around">
              <DatePicker
                margin="normal"
                label="觀測日期"
                value={selectedDate}
                onChange={this.handleDateChange}
                className={classes.datePicker}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                href={`?date=${selectedDate}`}
              >
                搜尋
              </Button>
            </Grid>
          </Paper>
        </MuiPickersUtilsProvider>

        <Paper className={classes.root}>
		 <TableContainer className={classes.container}>
          <Table stickyHeader className={classes.table}>
            <TableHead>
              <TableRow style={{ whiteSpace: "nowrap" }}>
                <TableCell>個案姓名</TableCell>
                <TableCell>個案編號</TableCell>
                <TableCell align="right">
                  {format(new Date(date), "MMM, dd")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.users.map(row => (
                <TableRow key={row.user_id}>
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.serial_number}
                  </TableCell>
                  <TableCell align="right">
                    <SleepChart data={row.data} user_id={row.user_id}/>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
		 </TableContainer>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(Activities);
